// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switch-toggle[data-v-0a79d176]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.switch-toggle[data-v-0a79d176]:before{position:relative;pointer-events:all!important}.switch-label[data-v-0a79d176]{pointer-events:none;margin-left:10px}.custom-switch-input-only>p[data-v-0a79d176]{margin-top:-21px}", ""]);
// Exports
module.exports = exports;
